import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { MultimediaThumbResponse } from '../../../shared/api/responses/multimedia-thumb.response';
import { getMiniThumbUrl } from '../../../shared/api/helpers/get-mini-thumb-url';
import { getAlt } from '../../../shared/api/helpers/get-alt';
import { MultimediaType } from '../../../shared/enums/multimedia-type';
import { AdminMultimediaContextOperationsResponse } from './admin-multimedia-context-operations.response';

@jsonObject
export class AdminMultimediaCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Number)
  public readonly size!: number;

  @jsonMember(String)
  public readonly mimeType!: string;

  @jsonMember(String)
  public readonly extension!: string;

  @jsonMember(String)
  public readonly title!: string;

  @jsonMember(String)
  public readonly downloadUrl!: string;

  @jsonMember(String)
  public readonly previewUrl!: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(String)
  public readonly description?: Nillable<string>;

  @jsonArrayMember(MultimediaThumbResponse)
  public readonly thumbs!: MultimediaThumbResponse[];

  @jsonMember(String)
  public readonly type!: MultimediaType;

  @jsonMember(AdminMultimediaContextOperationsResponse)
  public readonly contextOperations!: AdminMultimediaContextOperationsResponse;

  @jsonMember(String)
  private readonly alternativeText?: Nillable<string>;

  public get miniThumbUrl(): string {
    return getMiniThumbUrl(this.thumbs);
  }

  public get alt(): string {
    return getAlt(this.title, this.alternativeText);
  }
}
